import * as React from 'react'
import {
  MenuOption,
  useMatchedServiceLocationsSelector,
} from './useMatchedServiceLocationsSelector'

import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { Select } from '@workwave-tidal/core/components'
import { SelectProps } from '@workwave-tidal/core/components/Select'

type Props = ReturnType<typeof useMatchedServiceLocationsSelector> &
  Pick<SelectProps<MenuOption>, 'sx' | 'label' | 'placeholder'>

export function MatchedServiceLocationSelector(props: Props) {
  const {
    menuOptions,
    selectedLocation,
    onChangeSelectedLocation,
    label,
    placeholder,
    ...rest
  } = props

  const tidalThemeActive = useTidalThemeActive()

  return (
    <Select<MenuOption>
      {...rest}
      items={menuOptions}
      getLabel={(option) => option.label}
      required
      placeholder={placeholder}
      label={label || ''}
      value={
        menuOptions?.find((row) => row?.value == selectedLocation?.id) || null
      }
      optionMode={'normal'}
      onChange={onChangeSelectedLocation}
      density={tidalThemeActive ? 'normal' : 'compact'}
      disableClearOnBlur
      data-testid="matched-service-location-selector"
    />
  )
}

MatchedServiceLocationSelector.displayName = 'MatchedServiceLocationSelector'
